import {RegisterPage} from "modules/Auth";

export default RegisterPage;
